import { useOnchainInteractionsPoolToken } from './useOnchain';
import useGenericCall from './useGenericCall';
import { ApprovalType, PoolTokenType } from 'impermax-sdk';

export default function useAllowance(approvalType: ApprovalType, pendingApproval?: boolean, poolTokenTypeArg?: PoolTokenType) {
  return useGenericCall(
    useOnchainInteractionsPoolToken(poolTokenTypeArg), 
    onchainInteractionsPoolToken => onchainInteractionsPoolToken.getAllowance(approvalType), [pendingApproval]
  );
};